import { Component, OnInit, ViewChild } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { SupportService } from '../stores/support.service';
import { Ticket, User, TicketsComments } from 'shared';
import { DxDataGridComponent } from 'devextreme-angular';
import {Observable, ReplaySubject} from 'rxjs';
import {notify} from 'shared';

@Component({
  selector: 'app-tickets-grid',
  templateUrl: './tickets-grid.component.html',
  styleUrls: ['./tickets-grid.component.scss']
})
export class TicketsGridComponent implements OnInit {

  ds: DataSource;
  canEdit: boolean;
  canAdd: boolean;
  canDelete: boolean;
  ticketOwner: boolean;
  ticket: Ticket;
  comments: TicketsComments;
  newCommentContent: string;
  ticketAttachment: string;
  status_list: {};
  newCommentButtonDisabled:boolean;
  platformBaseurl: string;

  isNew: boolean;
  isTicketDetailVisible: boolean;

  @ViewChild(DxDataGridComponent, { static: true })

  grid: DxDataGridComponent;

  constructor(
    private supportService: SupportService,
    public user: User,
  ) {
    // Data source
    this.ds = supportService.newDataSource();

    // Permissions
    this.canEdit = user.can('edit tickets');
    this.canAdd = user.can('add tickets');
    this.ticketOwner = false;

    this.showTicket = this.showTicket.bind(this);
    this.newCommentButtonDisabled = true;

    this.ticketAttachment = "";
    this.platformBaseurl = "https://gos.graviton.ma"

    this.status_list = {
      "Open" : {
        "name": "Ouvert",
        "color": "#f44336"
      },
      "Replied": {
        "name": "Répondu",
        "color": "#ff9800"
      },
      "On Hold": {
        "name": "En attente",
        "color": "#ff9800"
      },
      "Resolved": {
        "name": "Résolu",
        "color": "#4caf50"
      },
      "Closed": {
        "name": "Fermé",
        "color": "#4caf50"
      },
    }
  }

  ngOnInit(): void {
  }

  onEditingStart(e: any) {
    this.isNew = false;
  }

  onInitNewRow(e: any) {
    this.isNew = true;
  }

  showTicket(e: any){


    if(e.row.data.raised_by == this.user.email){
      this.ticketOwner = true;
    } else {
      this.ticketOwner = false;
    }
    // change all img tags src from html string using regex
    const regex = /<img[^>]+src="([^">]+)"/g;
    let updatedHtml = e.row.data.resolution_details;
    let match;
    while ((match = regex.exec(e.row.data.resolution_details)) !== null) {
      const oldSrc = match[1];
      const newSrc = this.platformBaseurl+oldSrc;
      updatedHtml = updatedHtml.replace(oldSrc, newSrc);
    }
    e.row.data.resolution_details = updatedHtml;

    this.ticket = e.row.data;

    if(e.row.data._comments){
      this.ticket.comments = JSON.parse(e.row.data._comments)
    }
    this.isTicketDetailVisible = true;
    this.loadTicketComments(e.row.data);
  }

  loadTicketComments(ticket: Ticket){
    this.supportService.comments(ticket.name).subscribe(data => {
      for(var index in data.data){
        if(data.data[index].comment_type == "Attachment"){
          var url = data.data[index].content.match(/<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/)[2]
          data.data[index].content = this.platformBaseurl+url;
        }
      }
      this.ticket.comments = data.data;
    });
  }
  addComment(ticket: Ticket,content: string){
    this.supportService.addComment({"content":content,"id":ticket.name}).subscribe(data => {
      this.loadTicketComments(ticket);
      this.newCommentContent = "";
    });
  }
  onPopupContentReady(e) {
    var contentElement = e.component.content();
    contentElement.style.padding = '0px';
  }
  onCommentValueChanged(e) {
    this.newCommentContent = e.value;
    if(this.newCommentContent){
      this.newCommentButtonDisabled = false;
    } else {
      this.newCommentButtonDisabled = true;
    }
  }
  async closeTicket(ticket: Ticket){
    const confirmed = await confirm('Êtes-vous sûr de vouloir fermer le ticket ?');
    if (confirmed) {
      this.supportService.update(ticket.name,{"status":"Closed"}).subscribe(data => {
        this.isTicketDetailVisible = false;
        this.grid.instance.refresh();
        notify('Votre ticket: '+ticket.name+' a été fermé');
      });
    }

  }
  onUpload(e: any)  {
    this.convertFile(e.value[0]).subscribe(base64 => {
      this.ticketAttachment = base64;
    });
  }
  onRowInserting(e: any){
    // console.log(e);
    // console.log(this.ticketAttachment);
    e.data.attachment = this.ticketAttachment;
    // this.convertFile(e.value[0].name).subscribe(base64 => {
    //   this.ticketAttachement = base64;
    // });

  }
  editPopup(e: any) {
    // e.component.content().classList.add('tractor-edit-popup');
  }
  convertFile(file : File) : Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => result.next(btoa(event.target.result.toString()));
    return result;
  }

}
